/* GRADA Theme — theme.js (ES2020, no build step) */

/* Klaviyo onsite forms wait for the age gate.
   Klaviyo's Shopify app embed injects the consumer pop-up site-wide, and it mounts at
   z-index 90000 against the age gate's 240, so on a first visit it painted over the gate
   and covered the "I am over 18+" button: an alcohol offer shown to an unverified
   visitor, with no way past it. The pop-up carries the free-shipping code the under-$100
   gift boxes rely on, so it is held rather than removed. Same contract the cookie banner
   already uses: wait for grada:age-verified, then release.
   Hidden, not removed, so Klaviyo keeps its own state (its close button, its
   "already seen" cookie and its submit all behave normally after the release).
   It also waits for the cookie notice (17 Oct 2026): released the moment the gate closed,
   the pop-up's overlay covered the notice, so Decline could not be pressed. Now it waits
   until the visitor has answered the notice (grada:cookie-consent) or closed it with Escape. */
(function klaviyoWaitsForAgeGate() {
  var AGE_KEY = 'modal_dismissed_age';
  var CHOICE_KEY = 'grada.cookieChoice';
  var SEL = '[class*="kl-private-reset-css"], [class*="klaviyo-form-"], [data-testid="klaviyo-form"]';

  function verified() {
    try {
      return Boolean(window.localStorage.getItem(AGE_KEY));
    } catch (e) {
      return false;
    }
  }

  // Same record gradaConsent.choice() reads: localStorage first, then the cookie.
  function chosen() {
    var stored = null;
    try { stored = window.localStorage.getItem(CHOICE_KEY); } catch (e) {}
    if (stored === 'accepted' || stored === 'declined') return true;
    return /(?:^|; )grada_cookie_choice=(?:accepted|declined)(?:;|$)/.test(document.cookie);
  }

  /* No pop-up for Meta ad visitors (25 Oct 2026). Roscoe: "make sure the klaviyo
     pop up is not firing on META leads because that will kill the UX". This form's Klaviyo targeting is by URL
     path, and the ad's tags are gone after the first page, so the theme marks the visit instead: an
     fbclid, a Meta utm_source (Meta's {{site_source_name}} gives fb, ig, msg or an), a Facebook or
     Instagram referrer, or their in-app browser. The mark lasts 7 days, so a Meta visitor who comes
     back by typing grada.au is not hit on the return visit either. The pop-up is held (hidden), not
     removed, exactly as below, so Klaviyo's scroll lock comes off with it. */
  var META_KEY = 'grada.metaVisit';
  function metaVisit() {
    var now = Date.now(), hit = false;
    try {
      var q = new URLSearchParams(window.location.search);
      var src = (q.get('utm_source') || '').toLowerCase();
      if (q.has('fbclid') || /^(fb|ig|msg|an)$|^(facebook|instagram|meta|messenger|audience)/.test(src)) hit = true;
      if (!hit && document.referrer) {
        var host = new URL(document.referrer).hostname;
        if (/(^|\.)(facebook|instagram|messenger)\.com$|(^|\.)fb\.(com|me)$/.test(host)) hit = true;
      }
      if (!hit && /FBAN|FBAV|FB_IAB|FBIOS|Instagram/.test(navigator.userAgent || '')) hit = true;
    } catch (e) {}
    try {
      if (hit) { window.localStorage.setItem(META_KEY, String(now)); return true; }
      var at = Number(window.localStorage.getItem(META_KEY) || 0);
      return at > 0 && now - at < 7 * 864e5;
    } catch (e) {
      return hit;
    }
  }
  /* Nor on the contact page (26 Oct 2026): in the first live test the pop-up opened over the form while
     it was being filled in and took the press on Send. */
  var noPopup = metaVisit() || /^\/pages\/contact(\/|$)/.test(window.location.pathname);

  var ageDone = verified();
  var cookieDone = chosen();
  /* The wait for a screen of scrolling or 25 seconds held only on the page where the gate was answered;
     on the next page the pop-up came straight back (17 Oct 2026, overnight test). The first session
     now keeps waiting on every page until the visitor has looked around once. */
  var firstSession = false, engagedBefore = false;
  try { firstSession = window.sessionStorage.getItem('grada.klWait') === '1'; engagedBefore = window.sessionStorage.getItem('grada.klEngaged') === '1'; } catch (e) {}
  if (!noPopup && ageDone && cookieDone && (!firstSession || engagedBefore)) return;
  if (!ageDone || !cookieDone) { try { window.sessionStorage.setItem('grada.klWait', '1'); } catch (e) {} }

  var held = [];

  function outermost(node) {
    while (node && node.parentElement && node.parentElement !== document.body &&
           /kl-private-reset-css|klaviyo-form/.test(String(node.parentElement.className || ''))) {
      node = node.parentElement;
    }
    return node;
  }

  function hold(node) {
    node = outermost(node);
    if (!node || node.__gradaHeld) return;
    // With no pop-up wanted, hold only the pop-up (Klaviyo mounts it in a bare div on <body>),
    // never a form set inside a page section.
    if (noPopup && node.closest('main, .shopify-section')) return;
    node.__gradaHeld = true;
    node.__gradaDisplay = node.style.display;
    node.style.setProperty('display', 'none', 'important');
    held.push(node);
    // Klaviyo locks the page behind its modal. The age gate owns the lock until it closes.
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
  }

  function sweep() {
    var n = document.querySelectorAll(SEL);
    for (var i = 0; i < n.length; i++) hold(n[i]);
  }

  // Two nets, because the form can mount before we bind: Klaviyo's documented
  // klaviyoForms event, and an observer on inserted nodes.
  window.addEventListener('klaviyoForms', function (e) {
    var t = e && e.detail && e.detail.type;
    if (t === 'open' || t === 'embedOpen') sweep();
  });

  var observer = null;
  if (window.MutationObserver) {
    observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var el = added[j];
          if (!el || el.nodeType !== 1) continue;
          if (el.matches && el.matches(SEL)) hold(el);
          else if (el.querySelector && el.querySelector(SEL)) sweep();
        }
      }
    });
    observer.observe(document, { childList: true, subtree: true });
  }

  sweep();

  /* First visit (17 Oct 2026): with the gate and the notice answered, the pop-up was the next thing on
     screen, before the film or a single product. It now waits until the visitor has looked around:
     scrolled a screen, or 25 seconds on the site, whichever comes first. */
  var engaged = false;
  function engage() { if (engaged) return; engaged = true; try { window.sessionStorage.setItem('grada.klEngaged', '1'); } catch (e) {} release(); }
  function watchEngagement() {
    window.setTimeout(engage, 25000);
    window.addEventListener('scroll', function onScroll() {
      if (window.scrollY > window.innerHeight * 0.9) { window.removeEventListener('scroll', onScroll); engage(); }
    }, { passive: true });
  }
  var watching = false;

  function release() {
    if (noPopup) return;
    if (!ageDone || !cookieDone) return;
    if (!engaged) { if (!watching) { watching = true; watchEngagement(); } return; }
    if (observer) observer.disconnect();
    for (var i = 0; i < held.length; i++) {
      var node = held[i];
      node.__gradaHeld = false;
      if (node.__gradaDisplay) node.style.display = node.__gradaDisplay;
      else node.style.removeProperty('display');
    }
    held = [];
  }

  if (ageDone && cookieDone) release();
  window.addEventListener('grada:age-verified', function () { ageDone = true; release(); });
  window.addEventListener('grada:cookie-consent', function () { cookieDone = true; release(); });
  window.addEventListener('grada:cookie-dismissed', function () { cookieDone = true; release(); });
})();

/* Klaviyo's scroll lock, with no pop-up to close (16 Oct 2026). Klaviyo puts
   klaviyo-prevent-body-scrolling on <body> when its pop-up opens and removes it when the pop-up closes.
   If the pop-up is held, hidden or removed while the class stays, the page simply stops scrolling on a
   phone with nothing on screen to explain it. Roscoe hit "the scroll stopped working" on mobile. While
   the age gate is up it owns the lock; otherwise, if the class is on and no Klaviyo pop-up is actually
   visible, the lock comes off. A pop-up that is really showing keeps its lock. Same idea as
   unlockScroll() on the review card and Deal Builder pages. */
(function klaviyoScrollLockGuard() {
  var LOCK = 'klaviyo-prevent-body-scrolling';
  var SEL = '[class*="kl-private-reset-css"], [class*="klaviyo-form-"], [data-testid="klaviyo-form"]';

  function popupShowing() {
    var n = document.querySelectorAll(SEL);
    for (var i = 0; i < n.length; i++) {
      var c = window.getComputedStyle(n[i]);
      if (c.position !== 'fixed' || c.display === 'none' || c.visibility === 'hidden' || parseFloat(c.opacity) === 0) continue;
      var r = n[i].getBoundingClientRect();
      if (r.width > 40 && r.height > 40) return true;
    }
    return false;
  }

  function check() {
    var body = document.body;
    if (!body) return;
    var root = document.documentElement;
    if (!body.classList.contains(LOCK) && !root.classList.contains(LOCK)) return;
    var gate = document.querySelector('[data-age-gate]');
    if (gate && !gate.hidden) return;
    if (popupShowing()) return;
    body.classList.remove(LOCK);
    root.classList.remove(LOCK);
    body.style.removeProperty('overflow');
    root.style.removeProperty('overflow');
  }

  function start() {
    if (window.MutationObserver) {
      new MutationObserver(function () { setTimeout(check, 400); })
        .observe(document.body, { attributes: true, attributeFilter: ['class', 'style'], childList: true });
    }
    // Klaviyo can hide its pop-up without touching <body>; look again now and then for the first minute.
    var ticks = 0;
    var timer = setInterval(function () { check(); if (++ticks >= 30) clearInterval(timer); }, 2000);
    window.addEventListener('grada:age-verified', function () { setTimeout(check, 1500); });
    /* A page brought back by Safari's Back button keeps whatever lock it was stored with, and the
       one-minute check above has long finished; look again on return and on the first touch after it
       (Roscoe, 17 Oct 2026: the shop page would not scroll after a product page). */
    window.addEventListener('pageshow', function () { setTimeout(check, 300); setTimeout(check, 1500); });
    document.addEventListener('touchstart', function () { check(); }, { passive: true });
    window.addEventListener('klaviyoForms', function (e) {
      var t = e && e.detail && e.detail.type;
      if (t === 'close' || t === 'submit') setTimeout(check, 600);
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();

function formatMoney(cents) {
  /* Whole-dollar prices since 15 Oct 2026: $55, not $55.00; cents only when there are some */
  var s = (cents / 100).toFixed(2);
  return '$' + (s.slice(-3) === '.00' ? s.slice(0, -3) : s);
}

/* ============================================================
   CONSENT
   One place that tells Shopify's Customer Privacy API what the
   visitor chose. The app pixels (Meta, Google) and Klaviyo read
   that, not our banner. Since 16 Oct 2026 (Roscoe: Meta needs the
   data) tracking is on for a verified 18+ visitor unless they press
   Decline; the notice is an opt-out. Decline and "I am under 18"
   record no.
   ============================================================ */
var gradaConsent = (function () {
  var AGE_KEY = 'modal_dismissed_age';
  var DENIED_KEY = 'grada.ageDenied';
  var CHOICE_KEY = 'grada.cookieChoice';
  var CHOICE_COOKIE = 'grada_cookie_choice';
  var DENIED_FOR_MS = 24 * 60 * 60 * 1000;
  var api = null;
  var waiting = [];

  function get(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function put(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function ageDenied() {
    var at = Date.parse(get(DENIED_KEY) || '');
    if (!at) return false;
    if (Date.now() - at < DENIED_FOR_MS) return true;
    put(DENIED_KEY, null);
    return false;
  }
  function ageVerified() {
    return !ageDenied() && Boolean(get(AGE_KEY));
  }

  function choice() {
    var stored = get(CHOICE_KEY);
    if (stored === 'accepted' || stored === 'declined') return stored;
    var cookie = document.cookie.split('; ').filter(function (v) {
      return v.indexOf(CHOICE_COOKIE + '=') === 0;
    })[0];
    stored = cookie ? cookie.split('=')[1] : null;
    return stored === 'accepted' || stored === 'declined' ? stored : null;
  }

  function granted() {
    return ageVerified() && choice() !== 'declined';
  }

  function withApi(fn) {
    if (api) { fn(api); return; }
    waiting.push(fn);
  }

  // Tell Shopify, but only when its record differs from ours.
  function sync() {
    withApi(function (cp) {
      /* The API object can arrive before its methods do; calling a missing method threw, and inside the
         age gate's yes button that stopped the gate closing (seen live, 17 Oct 2026). Wait and retry. */
      if (!cp || typeof cp.setTrackingConsent !== 'function') {
        window.setTimeout(function () { var again = window.Shopify && window.Shopify.customerPrivacy; if (again && typeof again.setTrackingConsent === 'function') { api = again; sync(); } }, 1500);
        return;
      }
      var want = granted() ? 'yes' : 'no';
      var now = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
      if (now.analytics === want && now.marketing === want &&
          now.preferences === want && now.sale_of_data === want) return;
      var on = want === 'yes';
      cp.setTrackingConsent({
        analytics: on,
        marketing: on,
        preferences: on,
        sale_of_data: on
      }, function (res) {
        if (res && res.error) console.warn('GRADA consent:', res.error);
      });
    });
  }

  function ready() {
    api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api) return;
    var queue = waiting;
    waiting = [];
    queue.forEach(function (fn) { fn(api); });
  }

  if (window.Shopify && window.Shopify.customerPrivacy) {
    ready();
  } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) { console.warn('GRADA consent: API did not load', error); return; }
      ready();
    });
  }

  // The old "Okay" notice recorded nothing real; ask everyone again.
  put('grada.cookieConsent', null);
  document.cookie = 'grada_cookie_consent=; Max-Age=0; Path=/; SameSite=Lax';

  sync();

  return {
    ageDenied: ageDenied,
    ageVerified: ageVerified,
    choice: choice,
    acceptAge: function () {
      var at = new Date().toISOString();
      put(DENIED_KEY, null);
      put(AGE_KEY, at);
      sync();
      return at;
    },
    /* "I am under 18" is no longer remembered for 24 hours (Roscoe, 18 Oct 2026): a refresh or a
       return shows the gate again so a mis-tap can be corrected. */
    denyAge: function () {
      put(AGE_KEY, null);
      put(DENIED_KEY, null);
      sync();
    },
    choose: function (value) {
      put(CHOICE_KEY, value);
      document.cookie = CHOICE_COOKIE + '=' + value + '; Max-Age=31536000; Path=/; SameSite=Lax';
      sync();
      window.dispatchEvent(new CustomEvent('grada:cookie-consent', { detail: { status: value } }));
    }
  };
})();

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================================
     0. AGE GATE
     "I am under 18" records tracking as declined, offers a way
     out and is remembered for a day, so a reload does not simply
     ask again.
     ============================================================ */
  (function () {
    var gate = document.querySelector('[data-age-gate]');
    if (!gate) return;
    window.gradaAgeGateReady = true; /* the early handler in snippets/age-gate.liquid stands down */

    var denied = gate.querySelector('[data-age-denied]');
    var actions = gate.querySelector('.grada-age-gate__actions');
    var copy = gate.querySelector('.grada-age-gate__copy');
    var accept = gate.querySelector('[data-age-accept]');
    var deny = gate.querySelector('[data-age-deny]');
    var exit = gate.querySelector('.grada-age-gate__exit');
    var previousOverflow = '';

    var inerted = [];
    function setPageInert(on) {
      if (on) {
        Array.prototype.forEach.call(document.body.children, function (el) {
          if (el !== gate && !el.contains(gate) && !el.inert && el.tagName !== 'SCRIPT') { el.inert = true; inerted.push(el); }
        });
      } else {
        inerted.forEach(function (el) { el.inert = false; });
        inerted = [];
      }
    }

    function openGate() {
      previousOverflow = document.body.style.overflow;
      setPageInert(true);
      // The gate is visible in the HTML; the head script only hides it for a returning 18+ visitor.
      document.documentElement.classList.remove('grada-age-ok');
      gate.hidden = false;
      gate.style.display = '';
      document.body.style.overflow = 'hidden';
      /* Focus on "I am 18 or over" when the panel opens (18 Oct 2026) */
      window.setTimeout(function () {
        (accept || gate).focus();
      }, 0);
    }

    function closeGate() {
      setPageInert(false);
      gate.hidden = true;
      gate.style.display = 'none';
      document.body.style.overflow = previousOverflow;
    }

    function showDenied() {
      if (actions) actions.hidden = true;
      if (copy) copy.hidden = true;
      if (denied) denied.hidden = false;
      if (exit) exit.focus();
    }

    if (gradaConsent.ageVerified()) {
      closeGate();
      window.dispatchEvent(new CustomEvent('grada:age-verified', {
        detail: { acceptedAt: window.localStorage.getItem('modal_dismissed_age') }
      }));
    } else {
      openGate();
    }

    if (accept) {
      accept.addEventListener('click', function () {
        /* Close first: nothing after this may keep a visitor behind the gate (17 Oct 2026) */
        closeGate();
        var acceptedAt = null;
        try { acceptedAt = gradaConsent.acceptAge(); } catch (e) { console.error('GRADA: age accept', e); }
        window.dispatchEvent(new CustomEvent('grada:age-verified', { detail: { acceptedAt: acceptedAt } }));
      });
    }

    if (deny) {
      deny.addEventListener('click', function () {
        gradaConsent.denyAge();
        showDenied();
        /* Then back to the page they came from (Roscoe, 18 Oct 2026): another site they came from, else
           the previous page in this tab. With neither, the message stays and a refresh asks again. */
        var ref = document.referrer;
        var external = ref && ref.indexOf(window.location.host) === -1;
        window.setTimeout(function () {
          if (external) window.location.href = ref;
          else if (window.history.length > 1) window.history.back();
        }, 1200);
      });
    }
  })();

  /* ============================================================
     1. HEADER SCROLL
     ============================================================ */
  (function () {
    var header = document.querySelector('.grada-header');
    if (!header) return;

    var solidDefault = header.getAttribute('data-solid-default') === 'true';
    /* Homepage: the header sits clear over the hero film and turns cream as the film scrolls out
       from under it (Roscoe, 16 Oct 2026). Find Us, Contact, Wholesale and Values do the same with
       their hero photo (17 Oct 2026): a fixed 640px left the cream header over the cream page on a
       phone, where those heroes are 240 to 590px tall. Pages with neither keep 640px. */
    var film = document.querySelector('.grada-home-hero__media') || document.querySelector('.grada-page-hero, .grada-values-hero');

    function threshold() {
      if (!film) return 640;
      return Math.max(0, film.getBoundingClientRect().bottom + window.scrollY - header.offsetHeight);
    }

    /* Royal everywhere except over the home page film (Roscoe, 17 Oct 2026): pages with a photo
       hero no longer start clear, so only the home film keeps the scroll threshold. */
    var homeFilm = !!document.querySelector('.grada-home-hero__media');
    function onScroll() {
      if (solidDefault || !homeFilm || window.scrollY > threshold()) {
        header.classList.add('grada-header--solid');
      } else {
        header.classList.remove('grada-header--solid');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();


  /* ============================================================
     2. MOBILE MENU
     ============================================================ */
  (function () {
    var header = document.querySelector('.grada-header');
    var menu = document.querySelector('.grada-header__mobile-menu');
    var mobileItems = document.querySelectorAll('.grada-header__mobile-link');
    mobileItems.forEach(function (item, index) {
      item.style.setProperty('--item-index', index);
    });

    /* Keyboard and screen reader behaviour (17 Oct 2026): open, focus goes to the first link and
       the page behind (main, footer) is inert, so Tab and VoiceOver stay in the header; Tab wraps
       from the last link to the toggle; Escape closes and puts focus back on the toggle. The
       toggle's spoken name follows its visible word. */
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    var behind = [];
    function setBehindInert(on) {
      if (on) {
        var main = document.getElementById('main-content');
        var footer = document.querySelector('.grada-footer');
        footer = footer && (footer.closest('.shopify-section') || footer);
        [main, footer].forEach(function (el) {
          if (el && !el.inert) { el.inert = true; behind.push(el); }
        });
      } else {
        behind.forEach(function (el) { el.inert = false; });
        behind = [];
      }
    }
    function setToggles(open) {
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
      });
    }
    function focusables() {
      if (!header) return [];
      return Array.prototype.filter.call(header.querySelectorAll('a[href], button:not([disabled])'), function (el) {
        return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
      });
    }

    function closeMenu(returnFocus) {
      if (header) header.classList.remove('is-menu-open');
      if (menu) {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
      }
      setToggles(false);
      setBehindInert(false);
      document.body.style.overflow = '';
      if (returnFocus && toggles[0]) toggles[0].focus();
    }

    /* Leaving with the menu open froze the page behind it (inert, no scroll), and Safari's back button
       brings the page back exactly as it was left, so the shop page would not scroll after a product
       page (Roscoe, 17 Oct 2026). Close it as the page is put away and again when it comes back. */
    window.addEventListener('pagehide', function () { closeMenu(false); });
    window.addEventListener('pageshow', function () { closeMenu(false); });

    function openMenu() {
      if (header) header.classList.add('is-menu-open');
      if (menu) {
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
      }
      setToggles(true);
      setBehindInert(true);
      document.body.style.overflow = 'hidden';
      var first = menu && menu.querySelector('.grada-header__mobile-link');
      if (first) first.focus();
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* Safari does not focus a tapped button, so focus can still be on a menu link that is closing */
        if (header && header.classList.contains('is-menu-open')) closeMenu(Boolean(menu && menu.contains(document.activeElement)));
        else openMenu();
      });
    });

    /* The menu slides in like the side cart; a tap on the dimmed page closes it (17 Oct 2026) */
    var menuBackdrop = document.querySelector('[data-menu-backdrop]');
    if (menuBackdrop) menuBackdrop.addEventListener('click', function () { closeMenu(true); });

    document.querySelectorAll('.grada-header__mobile-link, .grada-header__mobile-secondary-link').forEach(function (link) {
      link.addEventListener('click', function () {
        closeMenu(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (!header || !header.classList.contains('is-menu-open')) return;
      if (event.key === 'Escape') {
        /* Escape over the side cart closes the cart only */
        if (!document.querySelector('.grada-cart.is-open')) closeMenu(true);
        return;
      }
      /* With the side cart open over the menu, Tab must be free to reach it */
      if (event.key !== 'Tab' || !header.contains(document.activeElement) || document.querySelector('.grada-cart.is-open')) return;
      var items = focusables();
      if (!items.length) return;
      var firstItem = items[0];
      var lastItem = items[items.length - 1];
      if (event.shiftKey && document.activeElement === firstItem) {
        event.preventDefault();
        lastItem.focus();
      } else if (!event.shiftKey && document.activeElement === lastItem) {
        event.preventDefault();
        firstItem.focus();
      }
    });

    /* The menu only exists below 1240px; widening the window past that closes it */
    var wide = window.matchMedia('(min-width: 1240px)');
    var onWide = function () { if (wide.matches && header && header.classList.contains('is-menu-open')) closeMenu(false); };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
  })();


  /* ============================================================
     2b. MOVING CONTENT: PAUSE AND PLAY (17 Oct 2026)
     The review rails, the Instagram strip and the product page
     ticker drift for ever. Each gets a small Pause/Play button
     (WCAG 2.2.2); CSS also stops a rail while the pointer or focus
     is on it. With reduced motion nothing moves, so no button.
     The home film has its own (sections/home-hero.liquid).
     ============================================================ */
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var rails = [
      ['.grada-shop-reviews', 'the reviews'],
      ['.grada-content-review-rail', 'the reviews'],
      ['.grada-instagram-strip', 'the Instagram strip'],
      ['.grada-pdp-marquee', 'the moving words']
    ];
    var icon = '<svg class="grada-motion-toggle__icon" viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false">' +
      '<path class="grada-motion-toggle__pause" d="M2.5 1.5H5v9H2.5zM7 1.5h2.5v9H7z" fill="currentColor"/>' +
      '<path class="grada-motion-toggle__play" d="M3 1.2l7.5 4.8L3 10.8z" fill="currentColor"/></svg>';
    rails.forEach(function (rail) {
      document.querySelectorAll(rail[0]).forEach(function (box) {
        if (box.querySelector('[data-motion-toggle]')) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'grada-motion-toggle';
        btn.setAttribute('data-motion-toggle', '');
        btn.innerHTML = icon + '<span class="grada-motion-toggle__label"></span>';
        var label = btn.querySelector('.grada-motion-toggle__label');
        function draw(paused) {
          box.classList.toggle('is-motion-paused', paused);
          btn.classList.toggle('is-paused', paused);
          btn.setAttribute('aria-label', (paused ? 'Play ' : 'Pause ') + rail[1]);
          label.textContent = paused ? 'Play' : 'Pause';
        }
        draw(false);
        btn.addEventListener('click', function () { draw(!box.classList.contains('is-motion-paused')); });
        box.appendChild(btn);
      });
    });
  })();


  /* ============================================================
     3. CART DRAWER
     ============================================================ */
  (function () {
    var cart = document.querySelector('.grada-cart');
    if (!cart) return;

    var itemsContainer = cart.querySelector('.grada-cart__items');
    var footer = cart.querySelector('.grada-cart__footer');
    var subtotalEl = cart.querySelector('[data-cart-subtotal]');
    var backdrop = cart.querySelector('.grada-cart__backdrop');
    var panel = cart.querySelector('.grada-cart__panel');
    var heading = cart.querySelector('.grada-cart__heading');
    var statusEl = cart.querySelector('[data-cart-status]');
    var errorEl = cart.querySelector('[data-cart-error]');
    var shipEl = cart.querySelector('[data-cart-ship]');

    /* The drawer is a modal dialog (17 Oct 2026). Opening it remembers what opened it, makes the
       header, page and footer behind it inert, and moves focus to Close; Tab stays inside it.
       Closing hands focus back to the opener. */
    var opener = null;
    var inerted = [];
    function setPageInert(on) {
      if (on) {
        Array.prototype.forEach.call(document.body.children, function (el) {
          if (el === cart || el.contains(cart) || el.inert || el.tagName === 'SCRIPT') return;
          if (el.matches('main, .grada-skip-link, .grada-header, .grada-footer') || el.querySelector('.grada-header, .grada-footer')) {
            el.inert = true;
            inerted.push(el);
          }
        });
      } else {
        inerted.forEach(function (el) { el.inert = false; });
        inerted = [];
      }
    }

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), textarea:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; }
      );
    }

    function focusHeading() {
      if (heading) heading.focus({ preventScroll: true });
      else if (panel) panel.focus({ preventScroll: true });
    }

    /* A polite status line reads out quantity, removal and subtotal changes */
    function announce(text) {
      if (!statusEl || !text) return;
      statusEl.textContent = '';
      setTimeout(function () { statusEl.textContent = text; }, 60);
    }

    /* The header cart button's name carries the count, so a screen reader hears the real number */
    function labelOpeners(n) {
      document.querySelectorAll('[data-cart-open]').forEach(function (b) {
        if (/^Open cart/.test(b.getAttribute('aria-label') || '')) b.setAttribute('aria-label', 'Open cart, ' + n + (n === 1 ? ' item' : ' items'));
      });
    }

    function openCart(from, opts) {
      if (!cart.classList.contains('is-open')) {
        var a = from || document.activeElement;
        opener = (a && a !== document.body && !cart.contains(a)) ? a : null;
        cart.classList.add('is-open');
        cart.setAttribute('aria-hidden', 'false');
        expressTried = false;
        document.body.style.overflow = 'hidden';
        setPageInert(true);
        var close = cart.querySelector('.grada-cart__close');
        /* Focus the drawer's heading, so a screen reader announces "Your cart" first (Shopify accessibility guidance, 17 Oct 2026) */
        if (heading) heading.focus({ preventScroll: true });
        else if (close) close.focus({ preventScroll: true });
        else if (panel) panel.focus({ preventScroll: true });
      }
      return refresh(opts);
    }

    /* Same as the menu: never store or restore the page with the cart's scroll lock on (17 Oct 2026) */
    window.addEventListener('pagehide', function () { closeCart(); });
    window.addEventListener('pageshow', function () {
      closeCart();
      if (!document.querySelector('.grada-header__mobile-menu.is-open')) document.body.style.overflow = '';
    });

    function closeCart() {
      if (!cart.classList.contains('is-open')) return;
      cart.classList.remove('is-open');
      cart.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setPageInert(false);
      var back = opener;
      opener = null;
      /* Not to a control screen readers cannot see (the phone sticky bar is aria-hidden) */
      if (back && document.contains(back) && !back.closest('[aria-hidden="true"]')) back.focus({ preventScroll: true });
    }

    function refresh(opts) {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { renderCart(data, opts); })
        .catch(function (err) { console.error('GRADA: cart fetch error', err); });
    }
    function fetchAndRender() { return refresh(); }

    /* Every cart change goes through here. A refused change (HTTP 422 at the stock limit) throws
       Shopify's own description; the caller re-reads the cart rather than drawing the error body,
       which has no items and used to show "Your cart is empty" over a full cart. */
    function cartPost(url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) {
            var err = new Error((data && (data.description || data.message)) || '');
            err.status = r.status;
            throw err;
          }
          return data;
        });
      });
    }
    function errorText(err) {
      var m = err && err.status && err.message;
      return (m && typeof m === 'string') ? m : 'That did not go through. Please try again.';
    }

    var stepupMap = {};
    try {
      var stepupEl = document.querySelector('[data-cart-stepup]');
      if (stepupEl) stepupMap = JSON.parse(stepupEl.textContent);
    } catch (e) { stepupMap = {}; }

    var singlesMap = {};
    try {
      var singlesEl = document.querySelector('[data-cart-singles]');
      if (singlesEl) singlesMap = JSON.parse(singlesEl.textContent);
    } catch (e) { singlesMap = {}; }

    /* Same rule as snippets/product-title.liquid: a size after the dash joins with a space,
       anything else with a comma, so the cart never shows the em dash in a product title. */
    /* No GRADA in front of a product name, except Merch (Roscoe, 17 Oct 2026) */
    function displayTitle(t, type) {
      if (type !== 'Merch') t = t.replace(/^GRADA /, '');
      var i = t.indexOf(' — ');
      if (i < 0) return t;
      var tail = t.slice(i + 3);
      return t.slice(0, i) + (/^\d+\s?ml\b|^\d+\s+litre/i.test(tail) ? ' ' : ', ') + tail;
    }

    /* Shopify splits one product into two lines when the $5 add-on offer allocates to one of
       them (even a $0 allocation), so 2 bottles plus the Mega Shaker read as two 1-bottle rows.
       Lines with the same variant and properties show as one row with the summed quantity. */
    function hasDiscount(it) {
      return (it.total_discount || 0) > 0 ||
        (it.line_level_discount_allocations || []).some(function (a) { return (a.amount || 0) > 0; });
    }
    function groupItems(items) {
      var rows = [];
      var byKey = {};
      items.forEach(function (it) {
        var k = it.variant_id + '|' + JSON.stringify(it.properties || {});
        var row = byKey[k];
        if (!row) {
          row = byKey[k] = { gkey: k, item: it, keys: [], qtys: [], quantity: 0, final_line_price: 0, original_line_price: 0, discounted: false };
          rows.push(row);
        }
        row.keys.push(it.key);
        row.qtys.push(it.quantity || 0);
        row.quantity += it.quantity || 0;
        row.final_line_price += it.final_line_price || 0;
        row.original_line_price += it.original_line_price || 0;
        if (hasDiscount(it)) row.discounted = true;
      });
      return rows;
    }

    /* The size or mix under the title: the variant title only, never the internal product type */
    /* The line under the name: what is in it, not the product type (Roscoe, 17 Oct 2026).
       snippets/cart-line-contents.liquid does the same on /cart, so change both together. */
    function variantLabel(it) {
      var h = it.handle || '', v = it.variant_title || '';
      if (h.indexOf('gift-box') > -1) return h.indexOf('nick-nora') > -1 ? '2x Nick & Nora Glasses, Shaker + Recipe Card' : '1x Japanese Coupe, Shaker + Recipe Card';
      if (h.indexOf('party-pack') > -1) return '5L Bag-in-Box, Mega Shaker + Recipe Card';
      if (h.indexOf('5l-bag-in-box') > -1) return 'About 50 Espresso Martinis';
      if (h === '2-pack' || h === '3-pack') return v.replace(/ [×x] /g, 'x ') + ' + Recipe Card';
      if (h.indexOf('700ml') > -1) { var n = parseInt(v, 10) || 0; return n === 1 ? '1x 700ml Bottle' : (n > 1 ? n + 'x 700ml Bottles' : ''); }
      return (v && v !== 'Default Title') ? v : '';
    }

    function rowTitle(row) {
      // The contents line carries the size and the glasses, so the name drops them (17 Oct 2026)
      return displayTitle(row.item.product_title || row.item.title || 'item', row.item.product_type)
        .replace(' 700ml', '').replace(', Two Nick & Nora', '').replace(', 5L Bag-in-Box with Mega Shaker', '');
    }

    function sr(text) {
      var s = document.createElement('span');
      s.className = 'sr-only';
      s.textContent = text;
      return s;
    }

    /* Free shipping is $100 or more (automatic discount). The footer's Shipping row says how far to
       go or that it is free (Cart Drawer 4b, 17 Oct 2026). */
    var FREE_SHIP = 10000;
    function shipValue(total) {
      var left = FREE_SHIP - (total || 0);
      return left > 0 ? 'Add ' + formatMoney(left) + ' for free' : 'Free';
    }

    /* Which cart lines belong to each add-on row */
    var addonLines = {
      mega: function (it) { return it.handle === 'mega-shaker-1-litre'; },
      cap: function (it) { return /^(cord-cap|five-panel-cap)/.test(it.handle || ''); },
      note: function (it) { return it.handle === 'handwritten-gift-note'; }
    };
    var addonNames = { mega: 'the Mega Shaker', cap: 'the GRADA Cap', note: 'the handwritten card' };

    function svgChevron() {
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 12 12');
      svg.setAttribute('width', '12');
      svg.setAttribute('height', '12');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d', 'M2.5 4.5L6 8l3.5-3.5');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.5');
      path.setAttribute('stroke-linecap', 'round');
      svg.appendChild(path);
      return svg;
    }

    var currentRows = [];
    var currentItems = [];
    var busy = false;

    /* Express pay (17 Oct 2026). Shopify prints its dynamic checkout buttons for the cart as it is at
       page render, so a page loaded with an empty cart shows none. Once the cart has something in it
       and no wallet showed, the side cart fetches them again (sections/cart-express.liquid), once per
       opening. The 18+ gate stays on the wrapper (assets/grada-age-confirm.js). */
    var expressInner = cart.querySelector('[data-age-gate-inner]');
    var expressTried = false;
    function refreshExpress(isEmpty) {
      if (!expressInner || isEmpty || expressTried) return;
      var el = expressInner.querySelector('shopify-accelerated-checkout-cart');
      var wallets = el ? el.getAttribute('wallet-configs') : '';
      if (wallets && wallets !== '[]') return;
      expressTried = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?section_id=cart-express', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.dynamic-checkout__content');
          if (content) expressInner.innerHTML = content.outerHTML;
        })
        .catch(function () {});
    }

    /* Ten of each line at most (Roscoe, 17 Oct 2026). A line over ten, from any add to cart, is
       quietly brought back to ten here, with no message (Roscoe). */
    var QTY_MAX = 10;
    var qtyClamping = false;
    function renderCart(data, opts) {
      if (!itemsContainer) return;
      opts = opts || {};
      var over = (data.items || []).filter(function (it) { return it.quantity > QTY_MAX; })[0];
      if (over && !qtyClamping) {
        qtyClamping = true;
        cartPost('/cart/change.js', { id: over.key, quantity: QTY_MAX })
          .then(function (d) { qtyClamping = false; renderCart(d); })
          .catch(function () { qtyClamping = false; });
      }
      itemsContainer.innerHTML = '';

      var items = data.items || [];
      var isEmpty = items.length === 0;
      var rows = groupItems(items);
      var total = data.total_price || 0;
      currentRows = rows;
      currentItems = items;

      if (itemsContainer) itemsContainer.style.display = isEmpty ? 'none' : '';
      if (footer) footer.style.display = isEmpty ? 'none' : '';
      var emptyEl = cart.querySelector('[data-cart-empty]');
      if (emptyEl) emptyEl.hidden = !isEmpty;
      document.querySelectorAll('[data-cart-count]').forEach(function (countEl) {
        countEl.textContent = String(data.item_count || 0);
      });
      labelOpeners(data.item_count || 0);
      cart.querySelectorAll('[data-cart-noun]').forEach(function (nounEl) {
        nounEl.textContent = data.item_count === 1 ? 'item' : 'items';
      });
      if (errorEl) {
        errorEl.textContent = opts.cartError || '';
        errorEl.hidden = !opts.cartError;
      }

      /* Add-on rows (16 Oct 2026), each shown only where it fits: the Mega Shaker with a bottle, pack
         or the 5L (the Party Pack carries one); the GRADA Cap with a gift box; the handwritten card
         with anything. Since Cart Drawer 4b (17 Oct 2026) a row whose product is already in the cart
         stays and shows Added, and a second tap takes it out. */
      var addons = cart.querySelector('[data-cart-addons]');
      if (addons) {
        var has = function (test) { return items.some(test); };
        var megaBuys = /^(01-single-origin-700ml|02-midnight-decaf-700ml|2-pack|3-pack|5l-bag-in-box-01-single-origin)$/;
        var show = {
          mega: has(function (it) { return megaBuys.test(it.handle || ''); }) &&
                !has(function (it) { return /party-pack/.test(it.handle || ''); }),
          cap: has(function (it) { return (it.product_type || '') === 'Gift Box'; }),
          note: !isEmpty
        };
        var any = false;
        addons.querySelectorAll('[data-cart-addon]').forEach(function (row) {
          var key = row.getAttribute('data-cart-addon');
          var on = !!show[key];
          row.hidden = !on;
          if (!on) return;
          any = true;
          var lines = items.filter(addonLines[key] || function () { return false; });
          var added = lines.length > 0;
          row.classList.toggle('is-added', added);
          var main = row.querySelector('.grada-cart__upsell-buy button');
          if (main) {
            main.textContent = added ? 'Added' : 'Add';
            if (key === 'note') {
              var fields = row.querySelector('[data-cart-note-fields]');
              if (added) {
                if (fields) fields.hidden = true;
                row.classList.remove('is-open');
                main.removeAttribute('aria-expanded');
                main.setAttribute('aria-pressed', 'true');
              } else {
                main.removeAttribute('aria-pressed');
                main.setAttribute('aria-expanded', fields && !fields.hidden ? 'true' : 'false');
              }
            } else {
              main.setAttribute('aria-pressed', added ? 'true' : 'false');
            }
          }
          /* The cap in the cart decides which style shows as picked */
          if (key === 'cap' && added) {
            var vid = String(lines[0].variant_id);
            row.querySelectorAll('[data-cart-cap-pick]').forEach(function (p) {
              var mine = p.getAttribute('data-cart-cap-pick') === vid;
              p.setAttribute('aria-checked', mine ? 'true' : 'false');
              if (mine) pickCap(row, p);
            });
          }
          /* "Unlocks free shipping" when this add-on alone takes the cart to $100 */
          var unlock = row.querySelector('[data-cart-unlock]');
          var price = Number(row.getAttribute('data-price')) || 0;
          if (unlock) unlock.hidden = added || total >= FREE_SHIP || total + price < FREE_SHIP;
        });
        addons.hidden = !any;
        var hintEl = addons.querySelector('[data-cart-addons-hint]');
        if (hintEl) {
          var left = FREE_SHIP - total;
          var noteRow = addons.querySelector('[data-cart-addon="note"]');
          var cardCloses = noteRow && !noteRow.hidden && !noteRow.classList.contains('is-added') &&
                           left > 0 && left <= (Number(noteRow.getAttribute('data-price')) || 0);
          hintEl.textContent = left <= 0 ? 'Shipping is free.' :
            (cardCloses ? 'Add a handwritten card and shipping is free.' : 'Add ' + formatMoney(left) + ' more for free shipping.');
        }
      }

      /* A gift box in the cart offers the corporate builder for 10 or more, under the last gift box */
      var lastBox = -1;
      rows.forEach(function (row, i) { if ((row.item.product_type || '') === 'Gift Box') lastBox = i; });

      rows.forEach(function (row, i) {
        var item = row.item;
        var title = rowTitle(row);
        var el = document.createElement('li');
        el.className = 'grada-cart__item';

        var lineEl = document.createElement('div');
        lineEl.className = 'grada-cart__line';

        var imageEl = document.createElement('div');
        imageEl.className = 'grada-cart__item-image';
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = title;
          img.loading = 'lazy';
          imageEl.appendChild(img);
        }

        var infoEl = document.createElement('div');
        infoEl.className = 'grada-cart__item-details';

        var topEl = document.createElement('div');
        topEl.className = 'grada-cart__item-top';

        var titleEl = document.createElement('p');
        titleEl.className = 'grada-cart__item-title';
        /* The size or mix sits on the line below, so the title is the product name alone. It links to the
           product, as the cart page's lines do (17 Oct 2026, overnight test). */
        if (item.url) {
          var titleLink = document.createElement('a');
          titleLink.href = item.url;
          titleLink.textContent = title;
          titleEl.appendChild(titleLink);
        } else {
          titleEl.textContent = title;
        }

        var priceEl = document.createElement('p');
        priceEl.className = 'grada-cart__item-price';
        priceEl.textContent = formatMoney(row.final_line_price);
        /* A pack line also shows its single-bottle total crossed out, as its product page does */
        var unitSingles = singlesMap[item.variant_id];
        if (row.original_line_price > row.final_line_price) {
          /* A discounted line (the $5 off add-ons, a code) shows its full price crossed out */
          var wasEl = document.createElement('s');
          wasEl.className = 'grada-cart__item-compare';
          wasEl.appendChild(sr('was '));
          wasEl.appendChild(document.createTextNode(formatMoney(row.original_line_price)));
          priceEl.appendChild(wasEl);
        } else if (unitSingles && unitSingles * row.quantity > row.final_line_price) {
          var compareEl = document.createElement('s');
          compareEl.className = 'grada-cart__item-compare';
          compareEl.appendChild(sr('bought as single bottles '));
          compareEl.appendChild(document.createTextNode(formatMoney(unitSingles * row.quantity)));
          priceEl.appendChild(compareEl);
        }

        topEl.appendChild(titleEl);
        topEl.appendChild(priceEl);
        infoEl.appendChild(topEl);

        var metaEl = document.createElement('p');
        metaEl.className = 'grada-cart__item-meta';
        metaEl.textContent = variantLabel(item);
        // The handwritten note shows its message in quotes (16 Oct 2026).
        if (item.properties && item.properties.Message) metaEl.textContent = '“' + item.properties.Message + '”';
        if (metaEl.textContent) infoEl.appendChild(metaEl);

        function control(tag, act, label, text, cls) {
          var b = document.createElement(tag);
          b.type = 'button';
          if (cls) b.className = cls;
          b.setAttribute('data-cart-act', act);
          b.setAttribute('data-row', String(i));
          b.setAttribute('aria-label', label);
          b.textContent = text;
          return b;
        }

        var removeBtn = control('button', 'remove', 'Remove ' + title, 'Remove', 'grada-cart__remove');

        /* Quantity (Cart Drawer 4b, 17 Oct 2026): "Qty 1" and a chevron over a clear native select,
           1 to 6 plus Remove, so the phone opens its own picker. A line already above 6 keeps its
           number in the list. Shopify holds a change to the stock on hand and the line says why. */
        var qtyEl = document.createElement('label');
        qtyEl.className = 'grada-cart__qty';
        var qtyText = document.createElement('span');
        qtyText.setAttribute('aria-hidden', 'true');
        qtyText.textContent = 'Qty ' + row.quantity;
        var select = document.createElement('select');
        select.setAttribute('data-cart-act', 'qty');
        select.setAttribute('data-row', String(i));
        select.setAttribute('aria-label', title + ' quantity');
        for (var n = 1; n <= QTY_MAX; n++) select.appendChild(new Option(String(n), String(n)));
        select.appendChild(new Option('Remove', '0'));
        select.value = String(row.quantity);
        qtyEl.appendChild(qtyText);
        qtyEl.appendChild(svgChevron());
        qtyEl.appendChild(select);

        var actionsEl = document.createElement('div');
        actionsEl.className = 'grada-cart__item-actions';
        actionsEl.appendChild(qtyEl);
        actionsEl.appendChild(removeBtn);

        infoEl.appendChild(actionsEl);

        /* Single bottles step up to the 3 bottles size at its saving, one tap. Only a real saving
           hides it: the Mega Shaker offer leaves a $0 allocation on the bottle line. */
        var up = stepupMap[item.variant_id];
        if (up && row.quantity < 3 && !row.discounted) {
          var useTwo = (row.quantity === 1 && up.twoId);
          var upTargetId = useTwo ? up.twoId : up.id;
          var upLabel = useTwo
            ? ('Make it a 2-Pack: ' + formatMoney(up.twoPrice) + ', save ' + formatMoney(up.twoSave) + ' + free shipping')
            : ('Make it 3 bottles: ' + formatMoney(up.price) + ', save ' + formatMoney(up.save));
          var upBtn = control('button', 'stepup', upLabel, upLabel, 'grada-cart__stepup');
          upBtn.setAttribute('data-cart-stepup-to', upTargetId);
          upBtn.setAttribute('data-cart-stepup-count', useTwo ? '2' : '3');
          infoEl.appendChild(upBtn);
        }

        /* A refused change (the stock limit) says why, on its own line */
        if (opts.error && opts.error.gkey === row.gkey) {
          var errLine = document.createElement('p');
          errLine.className = 'grada-cart__line-error';
          errLine.setAttribute('role', 'alert');
          errLine.textContent = opts.error.message;
          infoEl.appendChild(errLine);
        }

        el.setAttribute('data-gkey', row.gkey);
        lineEl.appendChild(imageEl);
        lineEl.appendChild(infoEl);
        el.appendChild(lineEl);

        if (i === lastBox) {
          var corp = document.createElement('p');
          corp.className = 'grada-cart__corporate';
          var corpLink = document.createElement('a');
          corpLink.href = '/pages/corporate-gift-boxes';
          corpLink.textContent = 'Corporate gift boxes with your logo';
          corp.appendChild(document.createTextNode('Giving 10 or more? '));
          corp.appendChild(corpLink);
          corp.appendChild(document.createTextNode('.'));
          el.appendChild(corp);
        }
        itemsContainer.appendChild(el);
      });

      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(total);
      }
      if (shipEl) {
        shipEl.textContent = shipValue(total);
        shipEl.classList.toggle('is-free', total >= FREE_SHIP);
      }
      refreshExpress(isEmpty);

      /* Keep keyboard focus where it was: on the same control of the same row, or on the
         heading when that row has gone. */
      if (opts.focus && cart.classList.contains('is-open')) {
        var target = null;
        itemsContainer.querySelectorAll('[data-cart-act="' + opts.focus.act + '"]').forEach(function (b) {
          var li = b.closest('[data-gkey]');
          if (!target && li && li.getAttribute('data-gkey') === opts.focus.gkey) target = b;
        });
        if (target) target.focus({ preventScroll: true });
        else focusHeading();
      }

      if (opts.say) {
        var said = typeof opts.say === 'function' ? opts.say(rows, data) : opts.say;
        announce(said);
      }
    }

    function findRow(rows, gkey) {
      for (var i = 0; i < rows.length; i++) { if (rows[i].gkey === gkey) return rows[i]; }
      return null;
    }

    /* Quantity, Remove and the step-up, for the rebuilt rows. Changes go by line key, so a row
       Shopify has split still moves as one. A higher quantity uses /cart/change.js, which holds to
       the stock on hand (/cart/update.js lets a cart go past it); a lower one or Remove uses
       /cart/update.js to set every line of the row in one call. */
    function changeRow(row, act, want, focusOn) {
      var title = rowTitle(row);
      var gkey = row.gkey;
      var updates = {};
      var request;
      var focusAct = focusOn || act;

      if (act === 'qty' && want > row.quantity) {
        request = cartPost('/cart/change.js', { id: row.keys[0], quantity: row.qtys[0] + (want - row.quantity) });
      } else if (act === 'qty') {
        var drop = row.quantity - want;
        for (var k = row.keys.length - 1; k >= 0; k--) {
          var take = Math.min(drop, row.qtys[k]);
          updates[row.keys[k]] = row.qtys[k] - take;
          drop -= take;
        }
        request = cartPost('/cart/update.js', { updates: updates });
      } else if (act === 'stepup') {
        /* Add the 3 bottles first; only once that succeeds, take the single bottles out, so a
           failed add can never leave the customer with fewer bottles. The add can re-split the
           lines, so their keys are read again from the cart first. */
        request = cartPost('/cart/add.js', { items: [{ id: Number(row.stepTo), quantity: 1 }] })
          .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
          .then(function (c) {
            (c.items || []).forEach(function (it) {
              if (it.variant_id + '|' + JSON.stringify(it.properties || {}) === gkey) updates[it.key] = 0;
            });
            return cartPost('/cart/update.js', { updates: updates });
          });
      } else {
        row.keys.forEach(function (key) { updates[key] = 0; });
        request = cartPost('/cart/update.js', { updates: updates });
      }

      busy = true;
      itemsContainer.setAttribute('aria-busy', 'true');
      var say = function (rows, data) {
        var now = findRow(rows, gkey);
        var sub = 'Subtotal ' + formatMoney(data.total_price) + '.';
        if (act === 'stepup') return 'Changed to ' + (row.stepCount || '3') + ' bottles. ' + sub;
        if (!now) return 'Removed ' + title + '. ' + (rows.length ? sub : 'Your cart is empty.');
        return title + ', quantity ' + now.quantity + '. ' + sub;
      };
      request
        .then(function (data) {
          if (data && data.items) renderCart(data, { focus: { gkey: gkey, act: focusAct }, say: say });
          else return refresh({ focus: { gkey: gkey, act: focusAct }, say: say });
        })
        .catch(function (err) {
          console.error('GRADA: cart change error', err);
          return refresh({ focus: { gkey: gkey, act: focusAct }, error: { gkey: gkey, message: errorText(err) } });
        })
        .then(function () {
          busy = false;
          itemsContainer.removeAttribute('aria-busy');
        });
    }

    if (itemsContainer) itemsContainer.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button[data-cart-act]');
      if (!btn || busy) return;
      var row = currentRows[Number(btn.getAttribute('data-row'))];
      if (!row) return;
      var act = btn.getAttribute('data-cart-act');
      if (act === 'stepup') { row.stepTo = btn.getAttribute('data-cart-stepup-to'); row.stepCount = btn.getAttribute('data-cart-stepup-count') || '3'; }
      changeRow(row, act, 0);
    });

    if (itemsContainer) itemsContainer.addEventListener('change', function (e) {
      var select = e.target.closest && e.target.closest('select[data-cart-act="qty"]');
      if (!select) return;
      var row = currentRows[Number(select.getAttribute('data-row'))];
      if (!row) return;
      var want = Number(select.value);
      if (busy) { select.value = String(row.quantity); return; }
      if (want === row.quantity) return;
      changeRow(row, want === 0 ? 'remove' : 'qty', want, 'qty');
    });
    /* Open triggers */
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openCart(btn); });
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () { closeCart(); });
    }

    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeCart(); });
    });

    document.addEventListener('grada:cart-open', function (e) {
      var d = (e && e.detail) || {};
      openCart(d.opener, d.cartError ? { cartError: d.cartError } : (d.say ? { say: d.say } : null));
    });

    /* Add-on rows: Add puts that row's variant in the cart, and Added takes it out again (Cart Drawer
       4b, 17 Oct 2026). The cap row picks Cord or Five panel; with a cap already in the cart a pick
       swaps it. The card row opens a message box, and its Add card button sends the message. */
    function pickCap(row, pick) {
      row.setAttribute('data-variant-id', pick.getAttribute('data-cart-cap-pick'));
      row.querySelectorAll('[data-cart-cap-pick]').forEach(function (p) { p.setAttribute('aria-checked', p === pick ? 'true' : 'false'); });
      var thumb = row.querySelector('[data-cart-cap-thumb]');
      if (thumb && pick.getAttribute('data-thumb') && thumb.getAttribute('src') !== pick.getAttribute('data-thumb')) thumb.src = pick.getAttribute('data-thumb');
    }
    /* One message line per add-on row: the stock limit, or a card with no message yet */
    function rowMessage(row, text) {
      var p = row.querySelector('[data-cart-addon-msg]');
      if (!p) {
        p = document.createElement('p');
        p.className = 'grada-cart__line-error';
        p.setAttribute('data-cart-addon-msg', '');
        p.setAttribute('role', 'alert');
        row.appendChild(p);
      }
      p.textContent = text || '';
      p.hidden = !text;
    }
    /* Focus stays on the row's own button when it can, or goes to the heading */
    function keepFocus(btn) {
      var a = document.activeElement;
      if (a && a !== document.body && panel.contains(a) && a !== btn) return;
      if (btn && btn.getClientRects().length && getComputedStyle(btn).visibility !== 'hidden') btn.focus({ preventScroll: true });
      else focusHeading();
    }
    function addonSay(verb, key) {
      return function (rows, data) { return verb + ' ' + addonNames[key] + '. Subtotal ' + formatMoney(data.total_price) + '.'; };
    }
    function removeAddon(row, btn) {
      var key = row.getAttribute('data-cart-addon');
      var updates = {};
      currentItems.filter(addonLines[key]).forEach(function (it) { updates[it.key] = 0; });
      rowMessage(row, '');
      btn.disabled = true;
      cartPost('/cart/update.js', { updates: updates })
        .then(function () { return refresh({ say: addonSay('Removed', key) }); })
        .catch(function (err) {
          console.error('GRADA: cart add-on error', err);
          rowMessage(row, errorText(err));
          return refresh();
        })
        .then(function () { btn.disabled = false; keepFocus(btn); });
    }

    cart.querySelectorAll('[data-cart-cap-pick]').forEach(function (pick) {
      pick.addEventListener('click', function () {
        var row = pick.closest('[data-cart-addon]');
        var vid = pick.getAttribute('data-cart-cap-pick');
        var inCart = currentItems.filter(addonLines.cap);
        if (!row.classList.contains('is-added') || !inCart.length) { pickCap(row, pick); return; }
        if (inCart.some(function (it) { return String(it.variant_id) === vid; }) || busy) return;
        /* Swap: the new cap goes in first, then the old one comes out (keys read again after the add) */
        pickCap(row, pick);
        rowMessage(row, '');
        busy = true;
        cartPost('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] })
          .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
          .then(function (c) {
            var updates = {};
            (c.items || []).forEach(function (it) { if (addonLines.cap(it) && String(it.variant_id) !== vid) updates[it.key] = 0; });
            return cartPost('/cart/update.js', { updates: updates });
          })
          .then(function () { return refresh({ say: 'Changed the cap to ' + pick.textContent.trim() + '.' }); })
          .catch(function (err) {
            console.error('GRADA: cart add-on error', err);
            rowMessage(row, errorText(err));
            return refresh();
          })
          .then(function () { busy = false; keepFocus(pick); });
      });
    });
    var noteOpen = cart.querySelector('[data-cart-note-open]');
    if (noteOpen) {
      noteOpen.addEventListener('click', function () {
        var row = noteOpen.closest('[data-cart-addon]');
        if (noteOpen.getAttribute('aria-pressed') === 'true') { removeAddon(row, noteOpen); return; }
        var fields = row.querySelector('[data-cart-note-fields]');
        fields.hidden = false;
        row.classList.add('is-open');
        noteOpen.setAttribute('aria-expanded', 'true');
        var msg = row.querySelector('[data-cart-note-msg]');
        if (msg) msg.focus();
      });
      var noteMsg = cart.querySelector('[data-cart-note-msg]');
      if (noteMsg) noteMsg.addEventListener('input', function () {
        if (noteMsg.value.trim()) {
          noteMsg.removeAttribute('aria-invalid');
          rowMessage(noteMsg.closest('[data-cart-addon]'), '');
        }
      });
    }
    cart.querySelectorAll('[data-cart-addon-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('[data-cart-addon]');
        if (btn.getAttribute('aria-pressed') === 'true') { removeAddon(row, btn); return; }
        var key = row.getAttribute('data-cart-addon');
        var line = { id: Number(row.getAttribute('data-variant-id')), quantity: 1 };
        var msg = row.querySelector('[data-cart-note-msg]');
        /* A card needs its message: a blank one cost $5 and read "No message given" */
        if (msg && !msg.value.trim()) {
          msg.setAttribute('aria-invalid', 'true');
          rowMessage(row, 'Write your message first.');
          msg.focus();
          return;
        }
        if (msg) line.properties = { Message: msg.value.trim() };
        rowMessage(row, '');
        btn.disabled = true;
        cartPost('/cart/add.js', { items: [line] })
          .then(function () {
            if (msg) {
              msg.value = '';
              row.querySelector('[data-cart-note-fields]').hidden = true;
              row.classList.remove('is-open');
            }
            return refresh({ say: addonSay('Added', key) });
          })
          .catch(function (err) {
            console.error('GRADA: cart add-on error', err);
            rowMessage(row, errorText(err));
            return refresh();
          })
          .then(function () {
            btn.disabled = false;
            /* The card's Add card button hides with its box, so focus goes to the row's Added button */
            keepFocus(msg ? noteOpen : btn);
          });
      });
    });

    /* The header count was a hardcoded 0 that changed only when the drawer opened, so every page load
       said Cart (0) with bottles in the cart. Liquid now prints cart.item_count; this keeps it true on a
       cached page and after Back from checkout, which restores the page from the bfcache unchanged. */
    function syncCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = String(data.item_count || 0);
          });
          labelOpeners(data.item_count || 0);
        })
        .catch(function () {});
    }
    syncCount();
    window.addEventListener('pageshow', function (event) { if (event.persisted) syncCount(); });

    document.addEventListener('keydown', function (event) {
      if (!cart.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closeCart();
        return;
      }
      /* Tab and Shift+Tab go round the drawer's own controls */
      if (event.key === 'Tab' && panel) {
        var list = focusables();
        if (!list.length) { event.preventDefault(); panel.focus(); return; }
        var first = list[0];
        var last = list[list.length - 1];
        var active = document.activeElement;
        if (!panel.contains(active)) { event.preventDefault(); (event.shiftKey ? last : first).focus(); }
        else if (event.shiftKey && (active === first || active === panel || active === heading)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && active === last) { event.preventDefault(); first.focus(); }
      }
    });

    document.addEventListener('grada:cart-add', function (e) {
      var d = e.detail || {};
      var variantId = d.variantId;
      var quantity = d.quantity || 1;
      if (!variantId) return;

      // Extra lines added with the product, e.g. the gift box's handwritten note (16 Oct 2026).
      // They go first and the product last, so the product lands at the top of the side cart.
      var items = (d.extraItems || []).concat([{ id: variantId, quantity: quantity }]);
      cartPost('/cart/add.js', { items: items })
        .then(function () {
          document.dispatchEvent(new CustomEvent('grada:cart-open', { detail: { opener: d.button } }));
        })
        .catch(function (err) {
          /* Say why next to the button, and still open the side cart: part of the add may have
             gone in, and the shopper should see what the cart holds. */
          console.error('GRADA: cart add error', err);
          var text = errorText(err);
          if (d.button) {
            var anchor = d.button.closest('form') || d.button;
            var p = anchor.parentNode && anchor.parentNode.querySelector('[data-add-error]');
            if (!p) {
              p = document.createElement('p');
              p.className = 'grada-add-error';
              p.setAttribute('data-add-error', '');
              p.setAttribute('role', 'alert');
              anchor.insertAdjacentElement('afterend', p);
            }
            p.textContent = text;
            p.hidden = false;
          }
          document.dispatchEvent(new CustomEvent('grada:cart-open', { detail: { opener: d.button, cartError: text } }));
        })
        .then(function () { document.dispatchEvent(new CustomEvent('grada:cart-add-done')); });
    });
  })();


  /* ============================================================
     4. ADD TO CART BUTTONS
     ============================================================ */
  (function () {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var variantId = btn.getAttribute('data-variant-id');
        /* A button inside a no-JS fallback form adds through the side cart instead of submitting */
        if (btn.form) e.preventDefault();
        if (!variantId || btn.getAttribute('data-busy')) return;
        /* A ticked handwritten note needs its message before anything is added: a blank one cost
           $5 and read "No message given" (17 Oct 2026) */
        var extraItems = [];
        var note = document.querySelector('[data-gift-note]');
        var noteOn = note && note.querySelector('[data-gift-note-toggle]');
        if (note && noteOn && noteOn.checked && btn.classList.contains('grada-pdp-add-to-cart')) {
          var noteMsg = note.querySelector('[data-gift-note-msg]');
          var text = noteMsg ? noteMsg.value.trim() : '';
          var prompt = note.querySelector('[data-gift-note-error]');
          if (!text) {
            if (noteMsg && !prompt) {
              prompt = document.createElement('p');
              prompt.className = 'grada-note-error';
              prompt.id = (noteMsg.id || 'gift-note-msg') + '-error';
              prompt.setAttribute('data-gift-note-error', '');
              prompt.setAttribute('role', 'alert');
              noteMsg.insertAdjacentElement('afterend', prompt);
              noteMsg.setAttribute('aria-describedby', prompt.id);
              noteMsg.addEventListener('input', function () {
                if (noteMsg.value.trim()) { prompt.hidden = true; noteMsg.removeAttribute('aria-invalid'); }
              });
            }
            if (prompt) { prompt.textContent = 'Write your message, or untick the note.'; prompt.hidden = false; }
            if (noteMsg) { noteMsg.setAttribute('aria-invalid', 'true'); noteMsg.focus(); }
            return;
          }
          if (prompt) prompt.hidden = true;
          extraItems.push({ id: Number(note.getAttribute('data-variant-id')), quantity: 1, properties: { Message: text } });
        }
        /* Feedback while the add runs, and no second add from a repeat tap on a slow connection.
           aria-disabled, not disabled: a disabled button drops keyboard focus to the page. */
        var label = btn.textContent;
        var errAnchor = btn.closest('form') || btn;
        var oldError = errAnchor.parentNode && errAnchor.parentNode.querySelector('[data-add-error]');
        if (oldError) oldError.hidden = true;
        btn.setAttribute('data-busy', '1');
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Adding';
        var restore = function () {
          document.removeEventListener('grada:cart-add-done', restore);
          if (!btn.getAttribute('data-busy')) return;
          btn.removeAttribute('data-busy');
          btn.removeAttribute('aria-disabled');
          btn.textContent = label;
        };
        document.addEventListener('grada:cart-add-done', restore);
        setTimeout(restore, 8000);
        /* Any ticked product page add-on (the Mega Shaker) rides along as its own line */
        if (btn.classList.contains('grada-pdp-add-to-cart')) {
          document.querySelectorAll('[data-pdp-addon]').forEach(function (addon) {
            var tick = addon.querySelector('[data-pdp-addon-toggle]');
            if (tick && tick.checked) {
              var pick = addon.querySelector('[data-addon-choice]:checked');
              extraItems.push({ id: Number(pick ? pick.value : addon.getAttribute('data-variant-id')), quantity: 1 });
            }
          });
        }
        document.dispatchEvent(new CustomEvent('grada:cart-add', {
          detail: { variantId: variantId, quantity: 1, extraItems: extraItems, button: btn }
        }));
      });
    });
  })();


  /* ============================================================
     5. ACCORDION
     ============================================================ */
  (function () {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion-item]');
        if (!item) return;

        var group = item.closest('.grada-accordion');
        var isOpen = item.getAttribute('data-open') === 'true';

        /* Close siblings in the same group */
        if (group) {
          group.querySelectorAll('[data-accordion-item][data-open="true"]').forEach(function (openItem) {
            if (openItem !== item) {
              openItem.setAttribute('data-open', 'false');
              var siblingTrigger = openItem.querySelector('[data-accordion-trigger]');
              if (siblingTrigger) siblingTrigger.setAttribute('aria-expanded', 'false');
            }
          });
        }

        var nextState = isOpen ? 'false' : 'true';
        item.setAttribute('data-open', nextState);
        trigger.setAttribute('aria-expanded', nextState);
      });
    });
  })();


  /* ============================================================
     6. FAQ TABS
     ============================================================ */
  (function () {
    document.querySelectorAll('[data-faq-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabValue = tab.getAttribute('data-faq-tab');
        var tabParent = tab.closest('.grada-faq-tabs__tab');
        var tabsContainer = tabParent ? tabParent.parentElement : null;

        /* Deactivate siblings */
        if (tabsContainer) {
          tabsContainer.querySelectorAll('[data-faq-tab]').forEach(function (sibling) {
            sibling.setAttribute('data-active', 'false');
            sibling.setAttribute('aria-selected', 'false');
          });
        }
        tab.setAttribute('data-active', 'true');
        tab.setAttribute('aria-selected', 'true');
        /* One Tab stop for the row: the chosen tab (roving tabindex, 17 Oct 2026) */
        if (tabsContainer) {
          tabsContainer.querySelectorAll('[data-faq-tab]').forEach(function (sibling) {
            sibling.setAttribute('tabindex', sibling === tab ? '0' : '-1');
          });
        }

        /* Show/hide panels */
        var section = tab.closest('[class*="grada-faq-tabs"]') || document;
        var panels = (section === document ? document : section.closest('section') || document)
          .querySelectorAll('.grada-faq-tabs__panel');

        /* Broaden scope if nothing found */
        if (!panels.length) {
          panels = document.querySelectorAll('.grada-faq-tabs__panel');
        }

        /* The panels ship with the hidden attribute, so toggle that, not style.display */
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-tab') !== tabValue;
        });
      });
    });

    /* Arrow keys move along the tabs and choose as they go; Home and End jump to the ends */
    document.querySelectorAll('.grada-faq-tabs__tabs[role="tablist"]').forEach(function (list) {
      list.addEventListener('keydown', function (event) {
        var tabs = Array.prototype.slice.call(list.querySelectorAll('[data-faq-tab]'));
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        next.focus();
        next.click();
      });
    });
  })();


  /* ============================================================
     7. PDP GALLERY: ARROWS, DOTS AND SCROLL-SNAP
     The rail scrolls natively (trackpad, touch). Arrows and dots
     only move it; the scroll position decides which dot is lit and
     whether an arrow shows, so every input stays in step.
     ============================================================ */
  (function () {
    var stage = document.querySelector('[data-gallery]');
    if (!stage) return;
    var rail = stage.querySelector('[data-gallery-rail]');
    var prev = stage.querySelector('[data-gallery-prev]');
    var next = stage.querySelector('[data-gallery-next]');
    var dots = stage.querySelectorAll('[data-gallery-dots] button');
    var count = rail.children.length;
    if (count < 2) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var activeIndex = -1;

    function current() {
      var width = rail.clientWidth;
      return width ? Math.round(rail.scrollLeft / width) : 0;
    }

    function update() {
      var index = Math.min(Math.max(current(), 0), count - 1);
      if (index === activeIndex) return;
      activeIndex = index;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      // A disabled button drops keyboard focus, so hand it to the other arrow first.
      if (index === 0 && document.activeElement === prev && next) next.focus();
      if (index === count - 1 && document.activeElement === next && prev) prev.focus();
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
    }

    function go(index) {
      index = Math.min(Math.max(index, 0), count - 1);
      rail.scrollTo({ left: index * rail.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    rail.addEventListener('scroll', update, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { go(activeIndex + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });

    update();
  })();


  /* ============================================================
     8. COOKIE CONSENT
     The panel asks once the age gate is passed. Accept and
     Decline both go to Shopify through gradaConsent; closing it
     with Escape records nothing, so under the 16 Oct opt-out
     tracking stays on and the notice asks again on the next page.
     "Cookie settings" in the footer reopens it.
     ============================================================ */
  (function () {
    var panel = document.querySelector('.grada-cookie-panel');
    if (!panel) return;

    var waitingForAge = false;
    var card = panel.querySelector('.grada-cookie-panel__card');
    var returnFocus = null;

    // Focus goes into the notice when it opens (17 Oct 2026); it sat after the footer, 49 Tabs away on the
    // 01 page. Deferred, because after the age gate the page stays inert until the gate has closed.
    function focusPanel() {
      var from = document.activeElement;
      if (from && from !== document.body && !panel.contains(from)) returnFocus = from;
      window.setTimeout(function () {
        if (card && panel.classList.contains('is-open')) card.focus({ preventScroll: true });
      }, 0);
    }

    // On close, back to where the visitor was, or to the start of the page when that is gone
    // (the age gate's button, or nothing). Escape used to leave focus at the end of the page.
    function restoreFocus() {
      var to = returnFocus;
      returnFocus = null;
      if (!to || !document.contains(to) || !to.getClientRects().length) to = document.querySelector('.grada-skip-link');
      if (to) to.focus({ preventScroll: true });
    }

    // While the panel is open the page reserves its height on phones (see grada.css), so the bar can
    // never leave Add to Cart, or anything else, sitting under it out of reach.
    function reserveSpace(open) {
      var root = document.documentElement;
      root.classList.toggle('grada-cookie-open', open);
      root.style.setProperty('--grada-cookie-h', open ? panel.offsetHeight + 'px' : '0px');
    }

    function closePanel() {
      var hadFocus = panel.contains(document.activeElement);
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      reserveSpace(false);
      if (hadFocus) restoreFocus();
    }

    function openPanel() {
      panel.style.display = '';
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      reserveSpace(true);
      focusPanel();
    }

    window.addEventListener('resize', function () {
      if (panel.classList.contains('is-open')) reserveSpace(true);
    });

    if (gradaConsent.choice()) {
      panel.style.display = 'none';
      closePanel();
    } else if (gradaConsent.ageVerified()) {
      openPanel();
    } else {
      waitingForAge = true;
      closePanel();
    }

    document.querySelectorAll('[data-cookie-accept]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        gradaConsent.choose('accepted');
        closePanel();
      });
    });

    document.querySelectorAll('[data-cookie-decline]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        gradaConsent.choose('declined');
        closePanel();
      });
    });

    document.querySelectorAll('[data-cookie-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openPanel();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) {
        closePanel();
        // Klaviyo's pop-up waits for the notice to go (klaviyoWaitsForAgeGate at the top).
        window.dispatchEvent(new CustomEvent('grada:cookie-dismissed'));
      }
    });

    window.addEventListener('grada:age-verified', function () {
      if (waitingForAge && !gradaConsent.choice()) {
        waitingForAge = false;
        openPanel();
      }
    });
  })();


  /* ============================================================
     9. REVEAL ON SCROLL
     ============================================================ */
  (function () {
    var revealEls = document.querySelectorAll('.reveal');
    if (!revealEls.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealEls.forEach(function (el) { observer.observe(el); });
  })();


  /* ============================================================
     10. MARQUEE PAUSE ON HOVER
     ============================================================ */
  (function () {
    var selectors = [
      '.grada-home-marquee__track',
      '.grada-home-review-band__track',
      '.grada-shop-reviews__track',
      '.grada-instagram-strip__track'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (track) {
        track.addEventListener('mouseenter', function () {
          track.style.animationPlayState = 'paused';
        });
        track.addEventListener('mouseleave', function () {
          track.style.animationPlayState = 'running';
        });
      });
    });
  })();

});
